import { LayoutContainer } from 'components/Layout';
import Text from 'components/Text';
import { useIsEditing } from 'hooks';
import type { ColorField, Field, SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';

interface Props extends SitecoreBlockProps {
	fields?: {
		backgroundColor?: ColorField;
		description?: Field<string>;
		heading?: Field<string>;
	};
}

export default function ContentIntroduction({ fields, params }: Props) {
	const isEditing = useIsEditing();

	if (
		!fields ||
		(!isEditing && !fields.heading?.value && !fields.description?.value)
	) {
		return null;
	}

	return (
		<LayoutContainer
			id={params?.anchor}
			outerClassName={getEditorMargin(params)}
			backgroundColor={fields.backgroundColor?.fields?.colorHex?.value}
		>
			<div className="max-w-col-6">
				<Text as="h1" field={fields.heading} />
				<Text as="pLarge" field={fields.description} />
			</div>
		</LayoutContainer>
	);
}
ContentIntroduction.displayName = 'ContentIntroduction';
